import type { ReferralData } from "shared/types";

export default class Referrals {
  referralCode: string | null;
  codeField = "code";
  codeFields = ["code", "dcode", "icode", "mcode"];

  constructor() {
    console.debug("New Referrals instance created");
    const search = new URLSearchParams(window.location.search);
    this.codeField =
      this.codeFields.find((code) => {
        return search.has(code);
      }) || this.codeField;
    this.referralCode = search.get(this.codeField);

    this.saveReferralData();
  }

  private saveReferralData(): void {
    if (typeof window === "undefined" || !window.localStorage) {
      console.debug("LocalStorage is not available, skipping referral info save.");
      return;
    }
    
    if (this.referralCode) {
      console.debug("Referral code found:", this.referralCode, this.codeField);

      const referralData = {
        code: this.referralCode,
        field: this.codeField,
      };

      try {
        localStorage.setItem("thr_referral_info", JSON.stringify(referralData));
      } catch (error) {
        console.error("Error saving referral info to localStorage:", error);
      }
    }
  }

  public getReferralData(): ReferralData | undefined {
    try {
      const referralInfo = localStorage.getItem("thr_referral_info");
      if (referralInfo) {
        return JSON.parse(referralInfo);
      }
    } catch (error) {
      console.error("Error parsing referral info from localStorage:", error);
    }
    return undefined;
  }
}
